import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.substr.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.date.now.js";
// 同步请求
export function syncXhr(url) {
  try {
    var data = null;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);

    xhr.onload = function (e) {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          data = JSON.parse(xhr.responseText);
        } else {
          console.error(xhr.statusText);
        }
      }
    };

    xhr.onerror = function (e) {
      console.error(xhr.statusText);
    };

    xhr.send(null);
    return data;
  } catch (err) {
    return null;
  }
} //  获取参数

export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r !== null) return decodeURIComponent(r[2]);
  return null;
}
/**
 * 将字符串解析成日期
 * @param str 输入的日期字符串，如'2014-09-13'
 * @param fmt 字符串格式，默认'yyyy-MM-dd'，支持如下：y、M、d、H、m、s、S，不支持w和q
 * @returns Date 解析后的Date类型日期
 */

export function parseDate(str, fmt) {
  fmt = fmt || 'yyyy-MM-dd';
  var obj = {
    y: 0,
    M: 1,
    d: 0,
    H: 0,
    h: 0,
    m: 0,
    s: 0,
    S: 0
  };
  fmt.replace(/([^yMdHmsS]*?)(([yMdHmsS])\3*)([^yMdHmsS]*?)/g, function (m, $1, $2, $3, $4, idx, old) {
    str = str.replace(new RegExp($1 + '(\\d{' + $2.length + '})' + $4), function (_m, _$1) {
      obj[$3] = parseInt(_$1);
      return '';
    });
    return '';
  });
  obj.M--; // 月份是从0开始的，所以要减去1

  var date = new Date(obj.y, obj.M, obj.d, obj.H, obj.m, obj.s);
  if (obj.S !== 0) date.setMilliseconds(obj.S); // 如果设置了毫秒

  return date;
}

function queryString(obj) {
  return Object.keys(obj).map(function (key) {
    typeof obj[key] === 'string' && (obj[key] = obj[key].replace(/\\+$/g, ''));
    return key + '=' + encodeURIComponent(typeof obj[key] === 'undefined' ? '' : obj[key]);
  }).join('&');
} // 日志上报, 上报到啄木鸟流水日志里 bossId 6306


export function log(msg, settingId) {
  try {
    console.info('[setting-cgi] ' + msg + '! settingId: ' + settingId);
    var data = {
      s_app: 'setting-cgi',
      dtime: Date.now(),
      s_path: location.pathname,
      s_host: location.host,
      s_protocol: location.protocol,
      s_url: location.href,
      Pwd: 1687574211,
      log: msg,
      level: 1,
      s_browser: settingId // setting-id 上报到s_browser这个字段

    };
    var client = new XMLHttpRequest();
    client.open('POST', 'https://btrace.video.qq.com/kvcollect?BossId=' + 6306 + '&_dc=' + Date.now());
    client.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    client.withCredentials = true;
    client.send(queryString(data));
  } catch (e) {}
}